import React, { type ReactNode } from 'react';

import { Thumbnail, type ThumbnailProps } from '@pkg/components';

import { Content, Details, LinkedContent, StyledCredits, Subtitle, ThumbnailWrapper, Title } from './styles';

export interface CreditsProps {
    title: string;
    subtitle?: string;
    // TODO: Consider an object to pass `altText`.
    thumbnail?: ThumbnailProps['imageUrl'];
    url?: string;
    compact?: boolean;
    children?: ReactNode;
}

export function Credits({ title, subtitle, thumbnail, url, compact = false, children }: CreditsProps) {
    const thumbnailMarkup = thumbnail?.length ? (
        <ThumbnailWrapper>
            <Thumbnail imageUrl={thumbnail} />
        </ThumbnailWrapper>
    ) : null;

    const titleMarkup = <Title>{title}</Title>;
    const subtitleMarkup = subtitle?.length ? <Subtitle>{subtitle}</Subtitle> : null;

    const contentMarkup = (
        <Content>
            {thumbnailMarkup}

            <Details>
                {titleMarkup}
                {subtitleMarkup}
            </Details>

            {children}
        </Content>
    );

    const interiorMarkup = url?.length ? <LinkedContent to={url}>{contentMarkup}</LinkedContent> : contentMarkup;

    return (
        <StyledCredits $compact={compact} $soloTitle={!subtitleMarkup}>
            {interiorMarkup}
        </StyledCredits>
    );
}
